import React, { useEffect, useRef } from "react";
import { auth } from "integrations/firebase/auth";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useSignInWithEmailLink } from "react-firebase-hooks/auth";
import { toast } from "utils/toast";

import { Loader } from "components/loading/Loader";
import { LoginLinkError } from "./components/LoginLinkError";

export function LoginLink() {
  const navigate = useNavigate();

  const { t } = useTranslation("login");
  const processing = useRef(false);

  const [signInWithEmailLink, user, , error] = useSignInWithEmailLink(auth);

  useEffect(() => {
    if (processing.current) {
      return;
    }

    processing.current = true;

    let email: string | null = null;
    try {
      email = window.localStorage.getItem("emailForSignIn");
    } catch {
      // Storage may be unavailable in private browsing
    }

    signInWithEmailLink(email!).then(() => {
      try {
        window.localStorage.removeItem("emailForSignIn");
      } catch {
        // Storage may be unavailable
      }
    });
  }, [signInWithEmailLink, processing]);

  useEffect(() => {
    if (!user) {
      return;
    }

    toast.success(t("login:success.toast.title"));

    navigate({ to: "/" });
  }, [user, navigate, t]);

  if (error) {
    return <LoginLinkError error={error} />;
  }

  return (
    <div className="flex flex-col space-y-8 h-full items-center justify-center">
      <Loader />
      <div className="font-semibold text-2xl">{t("login:link.loading")}</div>
    </div>
  );
}

export function LoginLinkPage() {
  return <LoginLink />;
}
